import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Cropper } from '@/components/Cropper';
import { useProductWorkflow } from '@/hooks/useProductWorkflow';

export function CropPage() {
  const navigate = useNavigate();
  const { masterImage, productCategory, productTitle, handleCropsComplete } = useProductWorkflow();

  useEffect(() => {
    if (!masterImage) {
      navigate('/upload');
    }
  }, [masterImage, navigate]);

  if (!masterImage) {
    return null;
  }

  const onCropsComplete = (crops: Parameters<typeof handleCropsComplete>[0]) => {
    handleCropsComplete(crops);
    navigate('/production');
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold mb-2">Crop Print Ratios</h2>
        <p className="text-muted-foreground">
          Define crop areas for all 5 print sizes
        </p>
      </div>
      <Cropper
        masterImage={masterImage}
        productCategory={productCategory}
        productTitle={productTitle}
        onCropsComplete={onCropsComplete}
      />
    </div>
  );
}
